import { $api, getHeaders, getUrlWithVersion } from '../../../api/api'
import { AppDispatch } from '../../../types/store'

export const changeUserSurveyStatus =
    (surveyId: string, status: 'postponed' | 'accepted' | 'declined') =>
    async (_dispatch: AppDispatch) => {
        try {
            const res = await $api.patch(
                getUrlWithVersion(`/surveys/${surveyId}`),
                { user_survey_status: status },
                { headers: getHeaders() }
            )
            return res.data
        } catch (error) {
            console.error('Error changing user survey status:', error)
            throw new Error('Failed to change user survey status')
        }
    }
